import { render, staticRenderFns } from "./component-c225c07b.vue?vue&type=template&id=67bcdf63&scoped=true&"
import script from "./component-c225c07b.vue?vue&type=script&lang=js&"
export * from "./component-c225c07b.vue?vue&type=script&lang=js&"
import style0 from "./component-c225c07b.vue?vue&type=style&index=0&id=67bcdf63&lang=scss&scoped=true&"
import style1 from "./component-c225c07b.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bcdf63",
  null
  
)

export default component.exports